import { FC, lazy } from 'react';

const LoginPageDefaultView = lazy(() => import('./default-view/LoginPageDefaultView'));

export const LoginPage: FC = () => <LoginPageDefaultView />;
